import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "./Contact.scss";
import Form from "../../components/Form/Form";

const Contact = () => {
  return (
    <main className="contact-page">
      <Header />
      <h1>Get in touch</h1>
      <Form />
      <Footer />
    </main>
  );
};

export default Contact;
